export const cartOrderNotesKey = () => {
  try {
    const userId = JSON.parse(localStorage.getItem('user') || '{}')?.id;
    return userId ? `cart-order-notes:${userId}` : null;
  } catch {
    return null;
  }
};

export const readCartOrderNotes = (propertyIds, key = cartOrderNotesKey()) => {
  if (!key) return {};
  try {
    const stored = JSON.parse(sessionStorage.getItem(key) || '{}');
    if (!stored || typeof stored !== 'object' || Array.isArray(stored)) return {};
    return Object.fromEntries(Object.entries(stored).filter(([id, note]) =>
      /^\d{1,10}$/.test(id) && typeof note === 'string' && note.length <= 2000 &&
      (!propertyIds || propertyIds.map(String).includes(id))
    ));
  } catch {
    return {};
  }
};

export const saveCartOrderNote = (propertyId, note, key = cartOrderNotesKey()) => {
  if (!key || !/^\d{1,10}$/.test(String(propertyId)) || typeof note !== 'string' || note.length > 2000) return false;
  try {
    const notes = readCartOrderNotes(undefined, key);
    const normalized = note.replace(/\r\n?/g, '\n').trim();
    if (normalized) notes[propertyId] = normalized;
    else delete notes[propertyId];
    if (Object.keys(notes).length) sessionStorage.setItem(key, JSON.stringify(notes));
    else sessionStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
};

export const clearCartOrderNotes = (propertyIds, key = cartOrderNotesKey()) => {
  if (!key) return;
  try {
    if (!propertyIds) {
      sessionStorage.removeItem(key);
      return;
    }
    const notes = readCartOrderNotes(undefined, key);
    propertyIds.forEach(id => delete notes[id]);
    if (Object.keys(notes).length) sessionStorage.setItem(key, JSON.stringify(notes));
    else sessionStorage.removeItem(key);
  } catch {
    // Checkout already succeeded; an inaccessible tab store must not turn it into an error.
  }
};
